/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { withFallback } from "kontrolEdge/helpers/formattersShappedData";
import { connectionIndex } from "../fwaas/ConnectionsHelpers";
import { fwaasColumns } from "../fwaas/FwaasData";
import type { ConnectionRef, Fwaas as SdwanHub } from "../fwaas/FwaasData";

export type { ConnectionRef, Fwaas as SdwanHub } from "../fwaas/FwaasData";

export { fwaasColumns as sdwanHubColumns };

const toConnArr = (x: unknown): ConnectionRef[] => {
  if (Array.isArray(x)) {
    return x.map((v: any) => {
      if (v && typeof v === "object") {
        const id = String(v.id ?? v.subscriptionId ?? "");
        const subscriptionId = String(v.subscriptionId ?? v.id ?? id);

        const cs = v.connectedService ?? {};
        const connectedServiceId =
          cs.id ?? v.connectedServiceId ?? undefined;
        const connectedServiceType =
          cs.type ?? v.connectedServiceType ?? undefined;
        const connectedServiceSubId =
          cs.subscriptionId ?? cs.name ?? v.connectedServiceSubId ?? undefined;

        return {
          id,
          subscriptionId,
          connectedServiceId,
          connectedServiceType,
          connectedServiceSubId,
        };
      }
      const s = String(v ?? "");
      return { id: s, subscriptionId: s };
    });
  }
  if (x == null) return [];
  const s = String(x);
  return [{ id: s, subscriptionId: s }];
};

/**
 * Maps API rows into the shared table model; `connections.sdwanInt` stays as
 * `sdwanInt` so the UI shows SDWI / SDWAN-INT (not FWINT/FWI).
 */
export const shapeSdwanHubData = (rows: any[]): SdwanHub[] => {
  return rows.map((p) => {
    const customer = p.customer
      ? {
          name: p.customer.name ?? "-",
          id: typeof p.customer.id === "number" ? p.customer.id : 0,
          chargebeeCustomerId:
            p.customer.chargebeeCustomerId ??
            p.customer.domain ??
            "-",
        }
      : undefined;

    const internet = toConnArr(p.connections?.internet);
    const cloudConnectivity = toConnArr(p.connections?.cloudConnectivity);
    const fwint = toConnArr(p.connections?.fwint);
    const sdwanInt = toConnArr(p.connections?.sdwanInt);
    const port = toConnArr(p.connections?.port);
    const datacenter = toConnArr(p.connections?.datacenter);
    const branch = toConnArr(p.connections?.branch);

    const buckets = {
      internet,
      cloudConnectivity,
      fwint,
      sdwanInt,
      port,
      datacenter,
      branch,
    };

    const visibleId = withFallback(p.subscriptionId ?? p.name);

    return {
      id: p.id,
      serviceId: visibleId,
      name: visibleId,
      customer,
      status: withFallback(p.status),
      connections: {
        ...buckets,
        raw: connectionIndex({ connections: buckets }),
      },
      tag: Array.isArray(p.tag)
        ? p.tag
        : p.tag != null
          ? [withFallback(p.tag)]
          : [],
    };
  });
};
